// External dependencies
import { Trans, useTranslation } from 'react-i18next';
import React from 'react';

// Internal dependencies`
import { userType } from '@/modules/users/client/users.prop-types';
import Board from '@/modules/core/client/components/Board.js';
import ManifestoText from './ManifestoText.component.js';

export default function Foundation({ user }) {
  const { t } = useTranslation('pages');

  return (
    <>
      <Board names="nordiclights">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <br />
              <br />
              <i className="icon-3x icon-heart-o"></i>
              <br />
              <br />
              <h2>{t('HostFolk')}</h2>
            </div>
          </div>
        </div>
      </Board>

      <section className="container container-spacer">
        <div className="row">
          <div className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8">
            <p className="lead">
              {t(`HostFolk is a homestay platform built around the idea that 
              hospitality can be transformative. It connects international 
              exchange students, independent travellers, and host families 
              through meaningful homestay experiences, fostering cultural 
              exchange, friendship, and personal growth.`)}
            </p>
          </div>
        </div>
      </section>

      <section className="vision-footer">
        <div className="container">
          <div className="row" id="mission-vision-values">
            <div className="col-xs-12 text-center hidden-xs">
              <h2>{t('Mission & Values')}</h2>
              <br />
            </div>

            <div className="col-sm-4 text-center">
              <h3 id="vision">{t('Human Connection')}</h3>
              <p className="lead">
                <em>
                  {t(
                    'HostFolk believes that opening your home opens your heart. It’s about real relationships, not just room rentals.',
                  )}
                </em>
              </p>
            </div>

            <div className="col-sm-4 text-center">
              <h3 id="mission">{t('Cultural Exchange')}</h3>
              <p className="lead">
                {t(
                  `Every stay is a chance to learn—from language and customs to food and folklore.`,
                )}
              </p>
            </div>

            <div className="col-sm-4 text-center">
              <h3 id="values">{t('Mutual Benefit')}</h3>
              <p className="lead">
                {t(
                  `Hosts earn extra income while guests gain a sense of belonging in a new country.`,
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="container container-spacer">
        <hr />
        <div className="row text-center">
          <div className="col-xs-12 col-sm-10 col-sm-offset-1">
            <h2>{t('Who It’s for')}</h2>
            <Trans t={t} ns="pages">
              <ul className="list-unstyled lead">
                <li>
                  <strong>{t('Hosts')}</strong>:{' '}
                  {t(
                    'Warm, welcoming individuals or families like Alice who want to share their culture and home.',
                  )}
                </li>
                <li>
                  <strong>{t('Guests')}</strong>:{' '}
                  {t(
                    'Curious travellers and students like Oliver seeking authentic, local experiences.',
                  )}
                </li>
              </ul>
            </Trans>
          </div>
        </div>
      </section>

      <section className="container container-spacer">
        <hr />
        <div className="row text-center">
          <div className="col-xs-12 col-sm-10 col-sm-offset-1">
            <h2>{t('What Makes It Special')}</h2>
            <Trans t={t} ns="pages">
              <ul className="list-unstyled lead">
                <li>
                  <strong>{t('Personalized Matches')}</strong>:{' '}
                  {t(
                    'Hosts and guests are paired based on interests, preferences, and compatibility.',
                  )}
                </li>
                <li>
                  <strong>{t('Supportive Community')}</strong>:{' '}
                  {t(
                    'HostFolk offers guidance, resources, and a network of like-minded people.',
                  )}
                </li>
                <li>
                  <strong>{t('Global Reach')}</strong>:{' '}
                  {t(
                    "Whether you're in Tokyo, Dublin, or São Paulo, HostFolk brings the world to your doorstep.",
                  )}
                </li>
              </ul>
            </Trans>
          </div>
        </div>
      </section>

      <section className="container container-spacer">
        <hr />
        <div className="row text-center">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <h2>{t('Impact')}</h2>
            <p className="lead">
              {t(
                'Hosts become cultural ambassadors while guests gain deeper, more meaningful travel experiences. Together, communities grow more inclusive and globally minded.',
              )}
            </p>
          </div>
        </div>
      </section>

      {/* Manifesto */}
      <Board
        className="board-primary board-inset"
        names="jungleroad"
        id="manifesto"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-offset-3 col-md-6 text-center lead font-brand-light">
              <ManifestoText></ManifestoText>
              {!user && (
                <p>
                  <br />
                  <br />
                  <a
                    href="/signup"
                    className="btn btn-lg btn-action btn-inverse"
                  >
                    {t('Join HostFolk')}
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
      </Board>
    </>
  );
}

Foundation.propTypes = {
  user: userType,
};
